import { FC } from 'react';
// components
import ExcipientLabelComponent from 'components/main/ExcipientLabel/Add';

const Add: FC = () => <ExcipientLabelComponent />;

export default Add;
